<template>
  <div
      :class="'content-wrapper pt-'+content.pt + ' '+ 'pr-'+content.pr + ' '+
                                'pb-'+content.pb + ' '+ 'pl-'+content.pl + ' ' + ' mt-'+content.mt+ ' mb-'+content.mb+ ' mr-'+content.mr+ ' ml-'+content.ml">
    <blocks-icon-block
        v-if="type === 'icon'"
        :content="content">
    </blocks-icon-block>
    <blocks-video-block
        v-if="type === 'video'"
        :content="content">

    </blocks-video-block>
    <blocks-text-block
        v-if="type === 'text'"
        :content="content">

    </blocks-text-block>
    <blocks-image-block
        v-if="type === 'image'"
        :content="content">

    </blocks-image-block>
    <blocks-list-block
        v-if="type === 'list'"
        :content="content">
    </blocks-list-block>

    <blocks-button-block
        v-if="type === 'button'"
        :content="content">
    </blocks-button-block>

    <blocks-navigation-block
        v-if="type === 'navigation'"
        :content="content">
    </blocks-navigation-block>

    <blocks-form-block
        v-if="type === 'form'"
        :content="content">
    </blocks-form-block>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import BlocksIconBlock from '@/components/Blocks/IconBlock'
import BlocksVideoBlock from '@/components/Blocks/VideoBlock'
import BlocksTextBlock from '@/components/Blocks/TextBlock'
import BlocksImageBlock from '@/components/Blocks/ImageBlock'
import BlocksListBlock from '@/components/Blocks/ListBlock'
import BlocksButtonBlock from '@/components/Blocks/ButtonBlock'
import BlocksNavigationBlock from '@/components/Blocks/NavigationBlock'
import BlocksFormBlock from '@/components/Blocks/FormBlock'

export default {
  props: {
    type: String,
    content: Object,
  },
  components: {
    draggable,
    BlocksIconBlock,
    BlocksVideoBlock,
    BlocksTextBlock,
    BlocksImageBlock,
    BlocksListBlock,
    BlocksButtonBlock,
    BlocksNavigationBlock,
    BlocksFormBlock
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
